export default __webpack_public_path__ + "static/media/among-us@2x.4e2387ac.webp";